import React from 'react';
import './TrustSection.css';
import { FaAward, FaUsers, FaClock } from 'react-icons/fa';

function TrustSection() {
    return (
        <section className="trust-section">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4 trust-item">
                        <FaAward className="trust-icon" />
                        <h3>Quality treatment backed by 15+ years of experience</h3>
                    </div>
                    <div className="col-12 col-md-4 trust-item">
                        <FaUsers className="trust-icon" />
                        <h3>Trusted by thousands of families in Vizag</h3>
                    </div>
                    <div className="col-12 col-md-4 trust-item">
                        <FaClock className="trust-icon" />
                        <h3>Available 24/7</h3>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TrustSection;
